export const inventoryReportData = {
    tasks: [
        {
            id: 1,
            name: "RCC Slab Casting- 3rd Floor",
            tower: "Tower- A",
            stage: "Structural Work",
            status: "Over",
            materials: [
                { name: "Cement (ACC)", planned: 850, consumed: 920, unit: "bags", usage: 108, status: "danger" },
                { name: "M- Sand", planned: 45, consumed: 48, unit: "tonnes", usage: 107, status: "danger" },
                { name: "Aggregates", planned: 65, consumed: 68, unit: "tonnes", usage: 105, status: "danger" }
            ],
            allMaterials: [
                { name: "Cement (ACC)", planned: 850, consumed: 920, unit: "bags", usage: 108, status: "danger" },
                { name: "M- Sand", planned: 45, consumed: 48, unit: "tonnes", usage: 107, status: "danger" },
                { name: "Aggregates", planned: 65, consumed: 68, unit: "tonnes", usage: 105, status: "danger" },
                { name: "Steel Bars (12mm)", planned: 5.5, consumed: 5.8, unit: "tonnes", usage: 105, status: "danger" },
                { name: "Steel Bars (16mm)", planned: 3.2, consumed: 3.4, unit: "tonnes", usage: 106, status: "danger" },
                { name: "Binding Wire", planned: 125, consumed: 132, unit: "kg", usage: 106, status: "danger" },
                { name: "Shuttering Oil", planned: 45, consumed: 38, unit: "liters", usage: 84, status: "warning" },
                { name: "Water", planned: 12000, consumed: 11500, unit: "liters", usage: 96, status: "warning" },
                { name: "Admixture", planned: 28, consumed: 30, unit: "kg", usage: 107, status: "danger" },
                { name: "Concrete Pumps", planned: 2, consumed: 2, unit: "nos", usage: 100, status: "neutral" },
                { name: "Labor Hours", planned: 450, consumed: 520, unit: "hrs", usage: 115, status: "danger" },
                { name: "Safety Nets", planned: 15, consumed: 18, unit: "nos", usage: 120, status: "danger" }
            ]
        },
        {
            id: 2,
            name: "Column reinforcement - Block A",
            tower: "Tower- B",
            stage: "Structural Work",
            status: "Warning",
            materials: [
                { name: "TMT Steel (16mm)", planned: 12.5, consumed: 10.8, unit: "tonnes", usage: 86, status: "warning" },
                { name: "TMT Steel (20mm)", planned: 8.5, consumed: 7.2, unit: "tonnes", usage: 85, status: "warning" },
                { name: "Binding Wire", planned: 85, consumed: 72, unit: "kg", usage: 85, status: "warning" }
            ],
            allMaterials: [
                { name: "TMT Steel (16mm)", planned: 12.5, consumed: 10.8, unit: "tonnes", usage: 86, status: "warning" },
                { name: "TMT Steel (20mm)", planned: 8.5, consumed: 7.2, unit: "tonnes", usage: 85, status: "warning" },
                { name: "Binding Wire", planned: 85, consumed: 72, unit: "kg", usage: 85, status: "warning" },
                { name: "Spacer Blocks", planned: 450, consumed: 400, unit: "nos", usage: 89, status: "warning" },
                { name: "Labor Hours", planned: 120, consumed: 115, unit: "hrs", usage: 96, status: "warning" },
                { name: "Welding Rods", planned: 25, consumed: 22, unit: "pkts", usage: 88, status: "warning" },
                { name: "Couplers", planned: 150, consumed: 142, unit: "nos", usage: 95, status: "warning" },
                { name: "Anchor Bolts", planned: 48, consumed: 45, unit: "nos", usage: 94, status: "warning" },
                { name: "Epoxy Resin", planned: 12, consumed: 10, unit: "liters", usage: 83, status: "warning" },
                { name: "Alignment Shims", planned: 200, consumed: 185, unit: "nos", usage: 92, status: "warning" },
                { name: "Lifting Belts", planned: 4, consumed: 4, unit: "nos", usage: 100, status: "neutral" }
            ]
        },
        {
            id: 3,
            name: "Plastering - 1st floor North",
            tower: "Tower- A",
            stage: "Plastering & Finishing",
            status: "OK",
            materials: [
                { name: "M- Sand", planned: 85, consumed: 58, unit: "tonnes", usage: 68, status: "neutral" },
                { name: "Cement (OPC)", planned: 320, consumed: 210, unit: "bags", usage: 66, status: "neutral" }
            ],
            allMaterials: [
                { name: "M- Sand", planned: 85, consumed: 58, unit: "tonnes", usage: 68, status: "neutral" },
                { name: "Cement (OPC)", planned: 320, consumed: 210, unit: "bags", usage: 66, status: "neutral" }
            ]
        },
        {
            id: 4,
            name: "Brickwork - 4th floor West wing",
            tower: "Tower- C",
            stage: "Brickwork & Masonry",
            status: "Warning",
            materials: [
                { name: "Red Bricks", planned: 18000, consumed: 15120, unit: "nos", usage: 84, status: "warning" },
                { name: "Sand", planned: 25, consumed: 22, unit: "tonnes", usage: 88, status: "warning" }
            ],
            allMaterials: [
                { name: "Red Bricks", planned: 18000, consumed: 15120, unit: "nos", usage: 84, status: "warning" },
                { name: "Sand", planned: 25, consumed: 22, unit: "tonnes", usage: 88, status: "warning" },
                { name: "Cement", planned: 120, consumed: 105, unit: "bags", usage: 87, status: "warning" },
                { name: "Lime Powder", planned: 15, consumed: 12, unit: "bags", usage: 80, status: "warning" },
                { name: "Water Container", planned: 10, consumed: 10, unit: "nos", usage: 100, status: "neutral" },
                { name: "Scaffolding Pipes", planned: 85, consumed: 85, unit: "nos", usage: 100, status: "neutral" },
                { name: "Clamps", planned: 120, consumed: 115, unit: "nos", usage: 96, status: "warning" },
                { name: "Plank Boards", planned: 45, consumed: 40, unit: "nos", usage: 89, status: "warning" },
                { name: "Labor Overtime", planned: 24, consumed: 32, unit: "hrs", usage: 133, status: "danger" },
                { name: "Wheelbarrows", planned: 5, consumed: 4, unit: "nos", usage: 80, status: "warning" }
            ]
        }
    ],
    insights: [
        "1 task over-consumed (RCC slab: 108% cement usage)",
        "2 tasks approaching threshold (Steel at 86%, Bricks at 84%)",
        "Overall material discipline maintained with 4 tasks within budget"
    ],
    recommendation: "Review steel consumption for Column reinforcement immediately; coordinate with engineer to prevent overrun."
};
